<script>
export default {
  name: "UiInfoTooltip",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
};
</script>
<template>
  <b-button
    v-b-tooltip.hover.topleft
    :title="content"
    variant="light"
    aria-label="Info"
    class="px-2"
    style="background-color: transparent; border: none"
  >
    <i class="fa fa-info-circle fa-lg text-gray-500" aria-hidden="true"></i>
  </b-button>
</template>
